const ScrollToTop = () => {};

export default ScrollToTop;
